import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Logo from "@/components/Logo";

const NAV_LINKS = [
  { to: "/comment-ca-marche", label: "Comment ça marche" },
  { to: "/signaux",           label: "Signaux analysés" },
  { to: "/blog",              label: "Blog" },
  { to: "/en-cas-de-doute",  label: "En cas de doute" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const handleHomeNavigation = () => {
    if (pathname === "/" && !window.location.hash) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      navigate("/");
    }
  };

  return (
    <header
      className="sticky top-0 z-50 bg-white/90 backdrop-blur-md border-b border-[#E4EAF0]"
      style={{ boxShadow: "0 1px 0 0 #E4EAF0" }}
      data-testid="main-header"
    >
      <div className="container-app">
        <div className="flex items-center justify-between h-16">
          <button 
            onClick={handleHomeNavigation}
            className="flex-shrink-0 hover:opacity-75 transition-opacity bg-transparent border-none cursor-pointer p-0"
            data-testid="header-logo"
          >
            <Logo size="md" />
          </button>

          {/* Desktop nav */}
          <nav className="hidden md:flex items-center gap-1" data-testid="desktop-nav">
            {NAV_LINKS.map(l => (
              <Link
                key={l.to}
                to={l.to}
                className={`px-3 py-1.5 rounded-lg text-sm transition-all duration-150 ${
                  pathname === l.to
                    ? "bg-[#EEF4F8] text-[#0F3D5C] font-medium"
                    : "text-[#3D5166] hover:bg-[#F2F6FA] hover:text-[#0E1621]"
                }`}
                style={{ fontFamily: "'DM Sans', sans-serif" }}
              >
                {l.label}
              </Link>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <button
              onClick={() => navigate("/#hero")}
              className="btn-primary py-2 px-5 text-sm bg-transparent border-none cursor-pointer"
              data-testid="header-cta"
            >
              Analyser un site →
            </button>
          </div>

          {/* Mobile burger */}
          <button
            className="md:hidden p-2 text-[#3D5166] hover:text-[#0E1621] rounded-lg hover:bg-[#F2F6FA] transition-colors"
            onClick={() => setOpen(!open)}
            aria-label="Menu"
            data-testid="mobile-menu-toggle"
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="md:hidden border-t border-[#E4EAF0] bg-white" data-testid="mobile-menu">
          <nav className="container-app py-3 flex flex-col gap-1">
            {NAV_LINKS.map(l => (
              <Link
                key={l.to}
                to={l.to}
                className="text-sm text-[#3D5166] py-2.5 px-3 rounded-lg hover:bg-[#F2F6FA] hover:text-[#0E1621] transition-colors"
                style={{ fontFamily: "'DM Sans', sans-serif" }}
                onClick={() => setOpen(false)}
              >
                {l.label}
              </Link>
            ))}
            <button
              onClick={() => {
                handleHomeNavigation();
                setOpen(false);
              }}
              className="btn-primary text-sm text-center mt-2 bg-transparent border-none cursor-pointer w-full"
            >
              Analyser un site →
            </button>
          </nav>
        </div>
      )}
    </header>
  );
}
